import type { ReactNode } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { cn } from "@/lib/cn";

export interface KPICardProps {
  label: string;
  value: ReactNode;
  /** gradient accent bar at the top, any CSS gradient */
  accent?: string;
  delta?: { label: string; direction: "up" | "down" | "neutral" };
  note?: ReactNode;
}

const DELTA_COLOR = {
  up: "text-success",
  down: "text-danger",
  neutral: "text-text3",
} as const;

export function KPICard({ label, value, accent, delta, note }: KPICardProps) {
  return (
    <div className="relative overflow-hidden bg-card border border-border rounded-lg p-4 transition-all duration-200 hover:-translate-y-0.5 hover:border-border2">
      {accent && <div className="absolute inset-x-0 top-0 h-1" style={{ background: accent }} />}
      <div className="text-[10.5px] font-semibold uppercase tracking-[0.08em] text-text3 mb-3">{label}</div>
      <div className="mono text-[25px] leading-none font-bold text-text mb-2">{value}</div>
      {delta && (
        <div className={cn("flex items-center gap-1 text-[11px]", DELTA_COLOR[delta.direction])}>
          {delta.direction === "up" && <TrendingUp className="h-3 w-3" />}
          {delta.direction === "down" && <TrendingDown className="h-3 w-3" />}
          {delta.label}
        </div>
      )}
      {note && <div className="text-[11px] text-text3">{note}</div>}
    </div>
  );
}
